import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AesService } from '../../../services/jwt-security/aes.service';
import { Config, WEB_CONFIG } from '../../../config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { CommonApiService } from '../../../services/api/common-api.service';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';

@Component({
  selector: 'sc-popup-login',
  templateUrl: './popup-login.component.html',
  styleUrls: ['./popup-login.component.css']
})
export class MyDialogPopupLoginComponent implements OnInit {
  public username = '';
  public password = '';
  public loading = false;
  public errorMessage = '';
  public apiUrl = '';
  public userForm: FormGroup = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });

  constructor(
    public dialogRef: MatDialogRef<MyDialogPopupLoginComponent>,
    private aesUtil: AesService,
    @Inject(WEB_CONFIG) private config: Config,
    private http: HttpClient,
    private translateService: TranslateService,
    private cookieService: CookieService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonApiService: CommonApiService
  ) {
    this.apiUrl = config.api_url + '/authorization-api';
  }

  public ngOnInit() {}

  public onLogin() {
    if (this.userForm.invalid) {
      this.errorMessage = this.translateService.instant(
        'CORE.LOGIN.ACCESS_DENIED'
      );
      return;
    }
    this.loading = true;
    this.errorMessage = '';

    this.login(
      { username: this.username, password: this.password },
      this.translateService.currentLang
    ).subscribe(
      user => {
        this.loading = false;
        sessionStorage.setItem('loginFlag', 'true');
        sessionStorage.removeItem('authToken');
        sessionStorage.setItem('authToken', user.token);
        this.cookieService.set('auth-mail', this.commonApiService.getUserDataFromToken().email);
        this.dialogRef.close(true);
      },
      () => {
        this.loading = false;
        this.errorMessage = this.translateService.instant(
          'CORE.LOGIN.ACCESS_DENIED'
        );
      }
    );
  }

  private login(user: any, language: string): Observable<any> {
    let url: string = this.apiUrl + '/login/findUser';
    if (!!isNotNullOrUndefined(language) && language !== '') {
      url += '?language=' + language;
    }

    user.password = this.aesUtil.encrypt(user.password);

    return this.http.post(url, user, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }
}
